import { render, staticRenderFns } from "./ILabLogo.vue?vue&type=template&id=6d258d22"
import script from "./ILabLogo.vue?vue&type=script&setup=true&lang=js"
export * from "./ILabLogo.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports